import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled", "title", "tab-index", "aria-label"]

import { ITextButtonProps } from '@/@types/components/ui/buttons';

import { computed } from 'vue';

import '@/components/ui/buttons/SmTextButton/style.scss';



export default /*#__PURE__*/_defineComponent({
  __name: 'SmTextButton',
  props: {
    nativeType: { default: 'button' },
    type: { default: 'primary' },
    disabled: { type: Boolean, default: false },
    title: { default: null },
    tabIndex: { default: 0 },
    ariaLabel: { default: null }
  },
  emits: ['keydown.enter', 'keydown.space'],
  setup(__props: any, { emit: emits }) {

const props = __props;





const className = computed((): string => {
  let className = '';

  if (props.type === 'primary') {
    className += ' sm-text-button--primary';
  }

  if (props.type === 'secondary') {
    className += ' sm-text-button--secondary';
  }

  if (props.type === 'success') {
    className += ' sm-text-button--success';
  }

  if (props.type === 'error') {
    className += ' sm-text-button--error';
  }

  if (props.type === 'warning') {
    className += ' sm-text-button--warning';
  }

  if (props.type === 'info') {
    className += ' sm-text-button--info';
  }

  if (props.disabled) {
    className += ' sm-text-button--disabled';
  }

  return className;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: props.nativeType,
    class: _normalizeClass(["sm-text-button", className.value]),
    disabled: props.disabled,
    title: props.title ? props.title : '',
    role: "button",
    "tab-index": props.tabIndex,
    "aria-label": props.ariaLabel ? props.ariaLabel : '',
    onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (emits('keydown.enter')), ["enter"])),
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emits('keydown.space')), ["space"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 42, _hoisted_1))
}
}

})